import { showAlert, showWarning, showError } from "./swal";

export const handleApiError = async (status, retryCallback, tryRefresh) => {
    switch (status) {
        case 401:
            await showAlert("warning", "Unauthorized", "Session expired. Please refresh token.", {
                confirmButtonText: "Refresh Token",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await tryRefresh(false);
                    await retryCallback();
                }
            });
            break;

        case 403:
            showWarning("Forbidden", "You don't have permission to perform this action.");
            break;

        case 500:
            showError("Server Error", "An internal error occurred. Please try again later.");
            break;

        default:
            showError("Error", "An unknown error occurred. Please try again.");
    }
};
